"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_redux_1 = require("react-redux");
const roomCreateStore_1 = require("@/room/room_create/roomCreateStore");
const react_i18next_1 = require("react-i18next");
const ToggleButton_1 = __importDefault(require("@mui/material/ToggleButton"));
const _1 = require(".");
const styled_1 = __importDefault(require("@emotion/styled"));
function default_1({ categoryList }) {
    var _a;
    const selectedCategoryId = (_a = (0, react_redux_1.useSelector)((state) => state.roomData.category)) === null || _a === void 0 ? void 0 : _a.id;
    const dispatch = (0, react_redux_1.useDispatch)();
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ css: { flex: 1, padding: '10px 16px 150px', overflowY: 'auto' } }, { children: (0, jsx_runtime_1.jsx)(CategoryScrollWrapper, { children: Boolean(categoryList.length) &&
                categoryList.map((category, index) => {
                    const { id, name } = category;
                    const isTransferCategory = (0, _1.getIsTransferCategory)(id);
                    const isSomInHyungTransferCategory = id === 1018;
                    return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsxs)(ToggleButton_1.default, Object.assign({ value: category, selected: selectedCategoryId === id, onChange: () => dispatch((0, roomCreateStore_1.setRoomCategory)(category)) }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "text_overflow body2 gray-80", css: { WebkitLineClamp: 2 } }, { children: name })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: `caption2 ${isTransferCategory
                                        ? 'primary-dark surface-primary-light'
                                        : 'secondary-main surface-blue-10'}`, css: {
                                        display: 'flex',
                                        justifyContent: 'center',
                                        width: '100%',
                                        borderRadius: '5px',
                                    } }, { children: isSomInHyungTransferCategory
                                        ? t('폼 양도/중고/현물')
                                        : isTransferCategory
                                            ? t('폼 양도/중고')
                                            : t('통판') }))] })) }, `category_${id}_${index}`));
                }) }) })));
}
exports.default = default_1;
const CategoryScrollWrapper = styled_1.default.div `
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  .MuiToggleButton-root {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    row-gap: 10px;
    width: 100%;
    padding: 8px;
    border: 1px solid var(--gray-10);
    border-radius: 4px;
    background-color: var(--white) !important;
  }
  .MuiToggleButton-root.Mui-selected {
    border: 1px solid var(--gray-80);
  }
`;
